/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  PerpLiquidityMining,
  PerpLiquidityMiningInterface,
} from "../PerpLiquidityMining";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "_claimant",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_balance",
        type: "uint256",
      },
    ],
    name: "Claimed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [],
    name: "candidate",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_liquidityProvider",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_begin",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_end",
        type: "uint256",
      },
    ],
    name: "claimStatus",
    outputs: [
      {
        internalType: "bool[]",
        name: "",
        type: "bool[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_liquidityProvider",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_week",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_claimedBalance",
        type: "uint256",
      },
      {
        internalType: "bytes32[]",
        name: "_merkleProof",
        type: "bytes32[]",
      },
    ],
    name: "claimWeek",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_liquidityProvider",
        type: "address",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "week",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "balance",
            type: "uint256",
          },
          {
            internalType: "bytes32[]",
            name: "merkleProof",
            type: "bytes32[]",
          },
        ],
        internalType: "struct IMerkleRedeem.Claim[]",
        name: "claims",
        type: "tuple[]",
      },
    ],
    name: "claimWeeks",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "claimed",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getLengthOfMerkleRoots",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getToken",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "merkleRootIndexes",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_begin",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_end",
        type: "uint256",
      },
    ],
    name: "merkleRoots",
    outputs: [
      {
        internalType: "bytes32[]",
        name: "",
        type: "bytes32[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_week",
        type: "uint256",
      },
      {
        internalType: "bytes32",
        name: "_merkleRoot",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "_totalAllocation",
        type: "uint256",
      },
    ],
    name: "seedAllocations",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "setOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "updateOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_liquidityProvider",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_week",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_claimedBalance",
        type: "uint256",
      },
      {
        internalType: "bytes32[]",
        name: "_merkleProof",
        type: "bytes32[]",
      },
    ],
    name: "verifyClaim",
    outputs: [
      {
        internalType: "bool",
        name: "valid",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "weekMerkleRoots",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

export class PerpLiquidityMining__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<PerpLiquidityMining> {
    return super.deploy(overrides || {}) as Promise<PerpLiquidityMining>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): PerpLiquidityMining {
    return super.attach(address) as PerpLiquidityMining;
  }
  connect(signer: Signer): PerpLiquidityMining__factory {
    return super.connect(signer) as PerpLiquidityMining__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): PerpLiquidityMiningInterface {
    return new utils.Interface(_abi) as PerpLiquidityMiningInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): PerpLiquidityMining {
    return new Contract(address, _abi, signerOrProvider) as PerpLiquidityMining;
  }
}
